import * as React from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import styled from '@emotion/styled';
import { withAuthenticationRequired } from '@auth0/auth0-react';
import UploadFileForm from './UploadFileForm';
import UploadHistory from './UploadHistory';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

const StyledTabPanelContainer = styled.div`
  flex: 1;
  display: flex;
`;

const StyledChildrenContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

const TabPanel = (props: TabPanelProps) => {
  const { children, value, index, ...other } = props;

  return (
    <StyledTabPanelContainer
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <StyledChildrenContainer>{children}</StyledChildrenContainer>}
    </StyledTabPanelContainer>
  );
};

const a11yProps = (index: number) => {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
};

const UploadFile = () => {
  const [value, setValue] = React.useState(0);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: '100%', display: 'flex', flexDirection: 'column' }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
          <Tab label="Upload New File" {...a11yProps(0)} />
          <Tab label="Upload History" {...a11yProps(1)} />
        </Tabs>
      </Box>
      <TabPanel value={value} index={0}>
        <UploadFileForm />
      </TabPanel>
      <TabPanel value={value} index={1}>
        <UploadHistory />
      </TabPanel>
    </Box>
  );
};

export default withAuthenticationRequired(UploadFile, {
  onRedirecting: () => <div>Redirecting you to the login page...</div>,
});
